import { render, staticRenderFns } from "./StarTrendingChart.vue?vue&type=template&id=4229880c&"
import script from "./StarTrendingChart.vue?vue&type=script&lang=js&"
export * from "./StarTrendingChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports